import { DonationStatus, DonationType, queryClient } from "@/constants";
import { CLIENT_API } from "@/services/axios-client";
import { useNotificationStore } from "@/states/zustand/notification";
import { useMutation, useQuery, UseQueryOptions } from "@tanstack/react-query";

export const useGetDonationsByMeditationRetreat = (
    {
        retreatId,
        page,
        type,
        status = DonationStatus.ACCEPTED,
        queryProps
    }: {
        retreatId?: number,
        page: number,
        type: DonationType,
        status?: DonationStatus,
        queryProps?: Omit<
            UseQueryOptions<
                PaginatedResponse<Donation>,
                Error,
                PaginatedResponse<Donation>
            >,
            "queryKey" | "queryFn"
        >
    }) => {
    const { data, isLoading, ...rest } = useQuery<
        PaginatedResponse<Donation>,
        Error,
        PaginatedResponse<Donation>
    >({
        queryKey: ['donations', type, page, retreatId, status],
        queryFn: () => CLIENT_API.getDonations({ retreatId, page, type, status}),
        ...queryProps,
    });

    return {
        data,
        isLoading,
        ...rest
    }
};

export const useUpdateDonationAmount = () => {
    const { mutate, isPending, ...rest } = useMutation({
        mutationKey: ['update-donation-amount'],
        mutationFn: ({ id, amount }: { id: number, amount: number }) => CLIENT_API.updateDonationAmount(id, amount),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ['donations']
            })
            useNotificationStore.getState().setNotification({
                type: 'success',
                message: 'လှူဒါန်းမှု ပမာဏ ပြောင်းလဲမှု အောင်မြင်ပါသည်။',
            });
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: 'error',
                message: error || 'လှူဒါန်းမှု ပမာဏ ပြောင်းလဲမှု မအောင်မြင်ပါ။',
            });
        }
    });

    return {
        mutate,
        isMutating: isPending,
        ...rest
    }
}

export const useDeleteDonationRequest = () => {

    const { mutate, isPending, ...rest } = useMutation({
        mutationKey: ['delete-donation-request'],
        mutationFn: (id: number) => CLIENT_API.deleteDonationRequest(id),
        onSuccess: (data) => {
            queryClient.invalidateQueries({
                queryKey: ['donations']
            });
            useNotificationStore.getState().setNotification({
                type: 'success',
                message: data?.message ?? 'လှူဒါန်းမှု တောင်းဆိုမှု ဖျက်သိမ်းမှု အောင်မြင်ပါသည်။',
            });
        },
        onError: (error: string) => {
            useNotificationStore.getState().setNotification({
                type: 'error',
                message: error || 'လှူဒါန်းမှု တောင်းဆိုမှု ဖျက်သိမ်းမှု မအောင်မြင်ပါ။',
            });
        }
    });

    return {
        mutate,
        isMutating: isPending,
        ...rest
    }
}